module.exports = __webpack_public_path__ + "img/roadmap-mobile.18a7a389.svg";